import { render, staticRenderFns } from "./enclosureDetail.vue?vue&type=template&id=2494316f&scoped=true&"
import script from "./enclosureDetail.vue?vue&type=script&lang=js&"
export * from "./enclosureDetail.vue?vue&type=script&lang=js&"
import style0 from "./enclosureDetail.vue?vue&type=style&index=0&id=2494316f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2494316f",
  null
  
)

export default component.exports